export enum ClientStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  UNAPPROVED = 'unapproved',
}
